module.exports = __webpack_public_path__ + "img/south-korea.9410ec0d.svg";